import React from 'react';

/**
 * 차트용 스켈레톤 로더 컴포넌트
 * 
 * @param {Object} props
 * @param {boolean} props.show - 로딩 표시 여부
 * @param {string} props.overlayClass - 오버레이 추가 클래스
 * @param {number} props.barCount - 스켈레톤 막대 개수 (기본값: 4)
 */
export function ChartSkeletonLoader({
    show = true,
    overlayClass = '',
    barCount = 4
}) {
    if (!show) return null;

    return (
        <div className={`absolute inset-0 flex items-center justify-center bg-white/80 backdrop-blur-sm ${overlayClass}`}>
            <div className="flex flex-col items-center gap-4">
                {/* 스피너 */}
                <div className="relative w-12 h-12">
                    <div className="absolute inset-0 border-4 border-[#E4E8F1] rounded-full"></div>
                    <div className="absolute inset-0 border-4 border-transparent border-t-[#6EA2FF] rounded-full animate-spin"></div>
                </div>
                {/* 스켈레톤 막대들 */}
                {/* <div className="w-full max-w-md space-y-3 px-4">
          {Array.from({ length: barCount }).map((_, i) => (
            <div key={i} className="flex items-center gap-3">
              <div className="w-20 h-4 bg-[#E4E8F1] rounded animate-pulse"></div>
              <div
                className="h-4 bg-gradient-to-r from-[#E4E8F1] via-[#6EA2FF]/30 to-[#E4E8F1] rounded animate-shimmer"
                style={{
                  width: `${30 + i * 15}%`,
                  backgroundSize: '200% 100%',
                  animation: 'shimmer 1.5s infinite'
                }}
              ></div>
            </div>
          ))}
        </div> */}
            </div>
            {/* <style>{`
        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }
      `}</style> */}
        </div>
    );
}

export default ChartSkeletonLoader;

